import React, { Component, Fragment } from 'react'
import Breadcrumb from "../../common/breadcrumb"
import { Doka } from './react-doka';
import queryString from "query-string";
import { reviseObject } from "../../api";
import { toast } from 'react-toastify';

export class MediaRevise extends Component {
    constructor(props) {
        super(props)
        const value=queryString.parse(this.props.location.search);
        this.handleDokaConfirm = this.handleDokaConfirm.bind(this);
        this.handleDokaCancel = this.handleDokaCancel.bind(this);

        this.state = {
            loading: true,
            pid: value.pid,
            format: 'free',
            crop: {},
            cropAspectRatio: 1,
            src: `https://licontent.nyc3.digitaloceanspaces.com/media/${value.pid}`

        }
    }

    handleDokaCancel(output) {
        this.props.history.push(`/admin/media/edit?pid=${this.state.pid}`)
    }

    onCopyUrl = (url) => {
        // Create new element
        var el = document.createElement('textarea');
        // Set value (string to be copied)
        el.value = url;
        // Set non-editable to avoid focus and move outside of view
        el.setAttribute('readonly', '');
        el.style = {position: 'absolute', left: '-9999px'};
        document.body.appendChild(el);
        // Select text inside element
        el.select();
        // Copy text to clipboard
        document.execCommand('copy');
        // Remove temporary element
        document.body.removeChild(el);
        toast.info("Item Copied");

    };

    handleDokaConfirm(output) {
        if (output.file instanceof Blob ) {
            const formData = new FormData();
            formData.append('format', output.data.crop.aspectRatio);
            formData.append('image', output.file, 'rev');   
            reviseObject('media', formData, this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {

                    this.onCopyUrl(d2.baseUrl);
                    this.props.history.push(`/admin/media/edit?pid=${this.state.pid}`)                
                }
            });   
        }
    }

    componentDidMount() {
        window.scrollTo(0, 180);     
    }

    render() {
        const { crop, cropAspectRatio, src } = this.state;

        setTimeout(function() {
            document.querySelector(".loader-wrapper").style = "display: none";
        }, 100);  

        return (
            <Fragment>
                <Breadcrumb title={"Revise Media"} parents={[{name: "Media List", url: "/admin/media/list"},
                {name: "Media Edit", url: `/admin/media/edit?pid=${this.state.pid}`}]} />

                <div className="container-fluid">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">                                    
                                <div className="col-sm-12">                                                              
                                    <Doka
                                        ref={ this.dokaRef }
                                        labelButtonCropAspectRatio={'Use Area'}
                                        style={{width: '90vw', height: '50vw' }}
                                        utils={['crop', 'filter', 'color', 'markup', 'resize']}
                                        outputCanvasBackgroundColor={'#ffffff'}
                                        crop={crop}
                                        cropAspectRatio={cropAspectRatio}
                                        src={ src }
                                        outputData={ true }
                                        cropShowSize={true}
                                        cropAllowToggleLimit={true}
                                        cropLimitToImageBounds={false}
                                        onConfirm={ this.handleDokaConfirm }
                                        onCancel={ this.handleDokaCancel }
                                        cropAspectRatioOptions={ [
                                                {
                                                    label: 'Free Form',
                                                    value: null
                                                },
                                                {
                                                    label: 'Blog Header',
                                                    value: 385/1370
                                                },
                                                {
                                                    label: 'Collection Header',
                                                    value: 385/1370
                                                },                                              {
                                                    label: 'Collection Image',
                                                    value: 219/440
                                                },
                                                {
                                                    label: 'Collection Icon',
                                                    value: 370/370
                                                },
                                                {
                                                    label: 'Page Banner',
                                                    value: 700/1920
                                                },
                                                {
                                                    label: 'Parallax Decor',
                                                    value: 408/315
                                                },
                                                {
                                                    label: 'Avatar',
                                                    value: 250/250
                                                },
                                                {
                                                    label: 'Team Member',
                                                    value: 600/400
                                                },
                                                {
                                                    label: 'Product Feature',
                                                    value: 520/400
                                                }
                                            ]}
                                        />
                                </div>
                            </div>   
                        </div>                           
                    </div>                           
                </div>
            </Fragment>
        )
    }
}
//}
export default MediaRevise


